module.exports = __webpack_public_path__ + "img/bcp.e485fff1.png";